import './mailings.js';
import './couriers.js';
import './users.js';
import './fields.js';
import './lists.js';
import './user_groups.js';
import './mailing_states.js';
import './changes.js';
import './templates.js';


// WEBPACK FOOTER //
// ./src/config/index.js